import splitio from '@splitsoftware/splitio';
import canUseDOM from '../canUseDom';

let featureFramework;

export const setupFeatureFramework = (authorizationKey, identity = {}) =>
  new Promise((resolve, reject) => {
    if (featureFramework) return;

    const config = {
      core: { authorizationKey },
      startup: { readyTimeout: 2 },
    };
    if (canUseDOM) config.core.key = identity.id;

    const sdk = splitio(config);
    featureFramework = sdk.client();
    featureFramework.on(featureFramework.Event.SDK_READY, resolve);
    featureFramework.on(featureFramework.Event.SDK_READY_TIMED_OUT, reject);
  });

export const getTreatment = (treatment, identity) => {
  if (!featureFramework) return 'control';
  if (canUseDOM) return featureFramework.getTreatment(treatment, identity);
  return featureFramework.getTreatment(identity.id, treatment, identity);
};



// WEBPACK FOOTER //
// ./src/common/features/splitio.js